// Include both MIME types and file extensions for better cross-platform support (especially Windows)
export const ALLOWED_IMAGE_UPLOAD_FILES = 'image/jpeg,image/png,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';
export const MAX_IMAGE_UPLOAD_SIZE_MB = 10; // 10MB
export const MAX_IMAGE_UPLOAD_SIZE = MAX_IMAGE_UPLOAD_SIZE_MB * 1024 * 1024; // 10MB
export const MAX_IMAGE_UPLOAD_COUNT = 18;